export default Object.freeze({
  PT: "+55 11 4950-8313",
  IT: "+39 010 890 9015",
  EN: "+1 669 201-1200",
  ES: "+1 669 201-1200",
});
